/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupplierLocationMappingValidationData
 */
export interface SupplierLocationMappingValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SupplierLocationMappingValidationData
     */
    supplier?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SupplierLocationMappingValidationData
     */
    supplierValue?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SupplierLocationMappingValidationData
     */
    oneAirLocation?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SupplierLocationMappingValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof SupplierLocationMappingValidationData
     */
    uniqueness?: ValidationMessage;
}

export function SupplierLocationMappingValidationDataFromJSON(json: any): SupplierLocationMappingValidationData {
    return SupplierLocationMappingValidationDataFromJSONTyped(json, false);
}

export function SupplierLocationMappingValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierLocationMappingValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'supplier': !exists(json, 'supplier') ? undefined : ValidationMessageFromJSON(json['supplier']),
        'supplierValue': !exists(json, 'supplierValue') ? undefined : ValidationMessageFromJSON(json['supplierValue']),
        'oneAirLocation': !exists(json, 'oneAirLocation') ? undefined : ValidationMessageFromJSON(json['oneAirLocation']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'uniqueness': !exists(json, 'uniqueness') ? undefined : ValidationMessageFromJSON(json['uniqueness']),
    };
}

export function SupplierLocationMappingValidationDataToJSON(value?: SupplierLocationMappingValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'supplier': ValidationMessageToJSON(value.supplier),
        'supplierValue': ValidationMessageToJSON(value.supplierValue),
        'oneAirLocation': ValidationMessageToJSON(value.oneAirLocation),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'uniqueness': ValidationMessageToJSON(value.uniqueness),
    };
}


